import { Injectable } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { environment as ENV } from "@environments/environment";

@Injectable()
export class SSOService {
  constructor(public auth: AuthService, private http: HttpClient) {}

  public fetchUserData(token: string): Observable<any> {
    return this.http.post(
      `${ENV.gateway.base_url}/cauth/api/turbo/us/user/data-for-admin`,
      "",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "text/plain;charset=UTF-8",
        },
      }
    );
  }
}
